<template>
  <div class="tags-content">
    <el-autocomplete
      class="tags-autocomplete"
      v-model="state"
      :fetch-suggestions="querySearchAsync"
      placeholder="请输入内容"
      placement="bottom"
      :popper-append-to-body="false"
      :trigger-on-focus="false"
      :select-when-unmatched="true"
      @select="handleSelect">
    </el-autocomplete>
    <span class="tag-span" v-for="(item, index) in tags" :key="index">
      <!-- <span v-if="item.length > 10">{{ item.substring(0, 10) }}...</span> -->
      <span>{{ item }}</span>
      <span class="el-icon-close" @click="delateItem(item)" style="cursor: pointer;margin:2px 0 0 5px"></span>
    </span>
  </div>
</template>

<script>
import { getTagsList } from '@/api/customer.js'
import { getAudTagList } from '@/api/set.js'
export default {
  name: 'tagsTemplate',
  props: ['value'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      state: '',
      tags: this.value
    }
  },
  watch: {
    value: function (val) {
      this.tags = val
    }
  },
  computed: {
  },
  methods: {
    loadAll(name) {
      let array = []
      getAudTagList(this.$route.query.modelId, name, 1, 10).then(res => {
        for (let item of res.data.result.list) {
          array.push({
            value: item.name,
            id: item.id
          })
        }
      })
      return array
    },
    querySearchAsync(queryString, cb) {
      let nilArray = []
      if (queryString === '') {
        cb(nilArray)
        return
      }
      getAudTagList(this.$route.query.modelId, queryString, 1, 10).then(res => {
        let array = []
        for (let item of res.data.result.list) {
          array.push({
            value: item.name
          })
        }
        let tmpArray = []
        for (let key in array) {
          let index = this.tags.indexOf(array[key].value)
          if (index === -1) {
            tmpArray.push({value: array[key].value})
          }
        }
        let arrays = [
          {
            value: '未发现' + this.state + '(回车可以添加新标签)'
          }
        ]
        if (tmpArray.length === 0) {
          cb(arrays)
        } else {
          cb(tmpArray)
        }
      })
    },
    handleSelect(item) {
      item.value = item.value.replace(/\s+/g, '')
      if (item.value === '') {
        _g.toastMsg('error', '请输入内容')
        this.state = ''
        return
      }
      let itemTmp = item.value.replace('(回车可以添加新标签)', '')
      let itemTmp1 = itemTmp.replace('未发现', '')
      for (let one of this.tags) {
        if (itemTmp1 === one) {
          _g.toastMsg('error', '请勿重复添加标签')
          this.state = ''
          return
        }
      }
      this.state = ''
      if (item.value.search('(回车可以添加新标签)') !== -1) {
        let tmpStr = item.value.replace('(回车可以添加新标签)', '')
        let tmpStr1 = tmpStr.replace('未发现', '')
        this.tags.push(tmpStr1)
      } else {
        this.tags.push(item.value)
      }
      this.$emit('change', this.tags)
    },
    delateItem(item) {
      let index = this.tags.indexOf(item)
      this.tags.splice(index, 1)
      this.$emit('change', this.tags)
    }
  },
  mounted() {
  },
  created() {
  }
}
</script>

<style scoped>
.el-icon-close {
  line-height: 15px;
  width: 15px;
  height: 15px;
  font-size: 12px;
  background-color: #CCCCCC;
  border-radius: 8px;
  color: #fff;
  padding: 0.5px;
}
</style>
